// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__VaHwH","range":"MonthRangeSwitch_range__1Dl2N","disabled":"MonthRangeSwitch_disabled__2pvFz"};